import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { LinkSection } from '../../types/link';
import { CommonModule } from '@angular/common';
import { Section, SectionAttributes } from '../../../app/types/section';
import { PlainImageSection, imageToPicture } from '../../../app/components/plain-image/plain-image.component';
import { AspectRatio, RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { OgImageDirective } from '../../../app/directives/og-image.directive';
import { iconArrowsRight } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { ButtonComponent } from '@knorr-bremse-portals/ngx-components/components/button';
import { LineClampComponent } from '@knorr-bremse-portals/ngx-components/components/line-clamp';
import { OverlayFigureComponent } from '@knorr-bremse-portals/ngx-components/components/overlay-figure';
import { ChipComponent } from '@knorr-bremse-portals/ngx-components/components/chip';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

interface Tag {
  label: string;
  link: string;
  query: {
    [k: string]: unknown;
  };
}

interface Teaser {
  image: PlainImageSection;
  tags: Tag[];
  headline: string;
  abstract: string;
  url: string;
  date: number;
}

type TeaserOverviewSwitcherSection = Section<
  {
    numColumns: 12 | 8;
    headline: string;
    link: LinkSection;
    teasers: Teaser[];
  } & SectionAttributes,
  [
    'numColumns',
    'headline',
    'link',
    'teasers',
  ],
  'teaser-overview-switcher'
>;

@Component({
    selector: 'section[app-teaser-overview-switcher]',
    styleUrls: ['./teaser-overview-switcher.component.scss'],
    templateUrl: './teaser-overview-switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule, EditorIdDirective,
        OgImageDirective,
        ButtonComponent,
        RouterOrExternalLinkDirective,
        LineClampComponent,
        IconComponent,
        OverlayFigureComponent,
        ChipComponent,
        PictureComponent,
        FsButtonComponent,
    ],
})
export class TeaserOverviewSwitcherComponent extends SectionComponent<TeaserOverviewSwitcherSection> {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected iconLink = iconArrowsRight;

  protected activeTeaserIndex = 0;

  protected onTeaserListClick(event: MouseEvent, index: number): void {
    if (this.activeTeaserIndex !== index) {
      this.activeTeaserIndex = index;
      event.preventDefault();
    }
  }

}
